import React from "react";
import { Camera } from "lucide-react";
import { resolveBackendUrl } from "@/lib/urls";

export default function PhotoTimeline({ photos }) {
  if (photos.length === 0) {
    return (
      <div className="text-[var(--eb-text-dim)] py-8 text-center">
        <Camera className="w-7 h-7 text-[var(--eb-text-faint)] mx-auto" />
        <div className="mt-3">No updates yet — agent will post photo proof here.</div>
      </div>
    );
  }
  return (
    <div className="eb-timeline">
      {photos.map((p) => (
        <div key={p.photo_id} className="relative pb-6">
          <span className="eb-dot" />
          <div className="text-[10px] uppercase tracking-[0.2em] text-[var(--eb-text-dim)]">
            {new Date(p.created_at).toLocaleString()}
          </div>
          <div className="eb-elev mt-2 p-3 flex items-start gap-4">
            {p.image_url && (
              <img
                src={resolveBackendUrl(p.image_url)}
                alt={p.caption}
                className="w-28 h-28 object-cover rounded-md border border-[var(--eb-border)]"
              />
            )}
            <div className="text-sm leading-relaxed">{p.caption}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
